<template>
  <f7-page>
    <f7-link
      class="back"
      @click="$f7router.back()">
      <f7-icon f7="chevron_left" color="white" />
    </f7-link>
    <WeatherForecast />
  </f7-page>
</template>

<script>
import WeatherForecast from '../modules/AtlasWeather/WeatherForecast'
export default {
  name: 'WeatherPage',
  components: {
    WeatherForecast
  }
}
</script>

<style lang="scss">
.back {
  position: absolute;
  top: 10px;
  left: 5px;
  z-index: 100;
}
</style>
